export type VerificationStatus = 'verified' | 'unverified' | 'failed';

type VerificationStatusData = {
  verified?: boolean;
};

export const fetchVerificationStatus = async (): Promise<VerificationStatus> => {
  try {
    const response = await fetch('/api/auth/verification-status', { cache: 'no-store' });
    if (!response.ok) {
      return 'failed';
    }
    const data = (await response.json()) as VerificationStatusData;
    return data.verified === true ? 'verified' : 'unverified';
  } catch {
    return 'failed';
  }
};
